import React from 'react';
import { Layout } from "antd";
import Slider from './Slider';
import TuLieuSliderHome from './TuLieu/TuLieuSliderHome';
import VideoSliderHome from './Video/VideoSliderHome';
import GallerySliderHome from './Gallery/GallerySliderHome';

const { Content } = Layout;

const ContentHome: React.FC = () => {

  return (
    <>
      <Content>
        <Slider />
      </Content>
      <Content className="QTI-content-home">
        <TuLieuSliderHome />
        <VideoSliderHome />
        <GallerySliderHome />
      </Content>
    </>
  );
};

export default ContentHome;